// LUMINA · pages/SubscribePage.jsx
// Phase 121 — 公开邮件订阅页 / Phase 123 — 品牌背书+法讯预览+隐私
// Sacred palette: gold #D4AF37 + parchment #FDFBF7 + dark text

import React, { useState, useEffect } from 'react';

const API = "/api";
const GD = "#D4AF37";
const BG = "#FDFBF7";
const TXT = "rgba(0,0,0,0.82)";
const SUBTLE = "rgba(0,0,0,0.55)";

const LIST_OPTIONS = [
  { value: "General", label: "General",    desc: "BTF 整体法讯法会教法" },
  { value: "宁玛",    label: "宁玛",       desc: "宁玛派法会教法" },
  { value: "萨迦",    label: "萨迦",       desc: "萨迦派法会教法" },
  { value: "噶举",    label: "噶举",       desc: "噶举派法会教法" },
  { value: "格鲁",    label: "格鲁",       desc: "格鲁派法会教法" },
  { value: "觉囊",    label: "觉囊",       desc: "觉囊派法会教法" },
];

export default function SubscribePage() {
  const [email, setEmail] = useState("");
  const [selected, setSelected] = useState(new Set(["General"]));
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [msg, setMsg] = useState("");
  const [events, setEvents] = useState([]);

  // ── Load recent events for preview ──
  useEffect(() => {
    fetch(`${API}/dharma/events`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setEvents(d.slice(0, 3)))
      .catch(() => {});
  }, []);

  const toggle = (val) => {
    const next = new Set(selected);
    if (next.has(val)) next.delete(val); else next.add(val);
    setSelected(next);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    setMsg("");
    try {
      const r = await fetch(`${API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email.trim(),
          labels: [...selected],
        }),
      });
      const d = await r.json();
      if (r.ok) {
        setStatus("success");
      } else {
        setStatus("error");
        setMsg(d.detail || "订阅失败，请重试");
      }
    } catch {
      setStatus("error");
      setMsg("网络错误，请稍后重试");
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: BG,
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      paddingTop: 48,
      paddingBottom: 80,
      fontFamily: "'Microsoft YaHei','微软雅黑',sans-serif",
    }}>
      <div style={{ maxWidth: 560, width: "100%", padding: "0 20px" }}>

        {/* ── Header ── */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <h1 style={{ color: GD, fontSize: 28, fontWeight: 700, margin: 0 }}>
            订阅 BTF 法讯
          </h1>
          <p style={{ color: SUBTLE, fontSize: 14, marginTop: 8, lineHeight: 1.6 }}>
            选择你感兴趣的传承，我们会发送相关法讯
          </p>
        </div>

        {/* ── BTF Brand Block (Phase 123) ── */}
        <div style={{
          background: "rgba(212,175,55,.05)", borderRadius: 10,
          padding: "16px 20px", marginBottom: 24,
          borderLeft: `3px solid ${GD}`,
        }}>
          <div style={{ color: TXT, fontSize: 13, lineHeight: 1.8 }}>
            <strong>BTF Canada 显密文教基金会</strong> — 为加拿大藏传佛教各传承法会、灌顶、闭关、口传活动提供法讯通知。
            订阅不是加入营销列表，而是<strong style={{ color: GD }}>结法缘、续法脉</strong>。
            我们尊重您的信仰空间，绝不将信息用于商业用途。
          </div>
        </div>

        {/* ── Form or Success ── */}
        {status === "success" ? (
          <div style={{
            background: "white", borderRadius: 12, padding: 36, textAlign: "center",
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📿</div>
            <div style={{ fontSize: 20, color: TXT, fontWeight: 600, marginBottom: 8 }}>
              感谢订阅 · 法缘相连
            </div>
            <div style={{ fontSize: 14, color: SUBTLE, lineHeight: 1.8 }}>
              {email} 已加入 BTF 法讯共修网络。<br />
              确认邮件已发送至您的邮箱，请查收。<br />
              法讯在重要活动前即时发送，不会频繁打扰。
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{
            background: "white", borderRadius: 12, padding: 28,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          }}>

            {/* Email */}
            <label style={{ color: TXT, fontSize: 14, fontWeight: 600, display: "block", marginBottom: 6 }}>
              邮箱
            </label>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              style={{
                width: "100%", padding: "10px 14px", fontSize: 15,
                border: "1px solid #ddd", borderRadius: 8,
                outline: "none", boxSizing: "border-box",
                fontFamily: "inherit",
              }}
              onFocus={e => e.target.style.borderColor = GD}
              onBlur={e => e.target.style.borderColor = "#ddd"}
            />

            {/* Labels */}
            <div style={{ marginTop: 24 }}>
              <p style={{ color: TXT, fontSize: 14, fontWeight: 600, margin: "0 0 10px 0" }}>
                传承选择
              </p>
              {LIST_OPTIONS.map(opt => {
                const checked = selected.has(opt.value);
                return (
                  <label
                    key={opt.value}
                    style={{
                      display: "flex", alignItems: "flex-start", gap: 10,
                      padding: "10px 0", cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggle(opt.value)}
                      style={{ marginTop: 2, accentColor: GD, width: 16, height: 16 }}
                    />
                    <div>
                      <div style={{ color: TXT, fontSize: 14, fontWeight: 500 }}>{opt.label}</div>
                      <div style={{ color: SUBTLE, fontSize: 12, marginTop: 2 }}>{opt.desc}</div>
                    </div>
                  </label>
                );
              })}
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={status === "loading"}
              style={{
                width: "100%", marginTop: 24, padding: "12px 0",
                background: status === "loading" ? "#ccc" : GD,
                color: "white", border: "none", borderRadius: 8,
                fontSize: 16, fontWeight: 600,
                cursor: status === "loading" ? "not-allowed" : "pointer",
                fontFamily: "inherit",
              }}
            >
              {status === "loading" ? "提交中..." : "订阅"}
            </button>

            {/* Status */}
            {msg && (
              <p style={{
                marginTop: 14, textAlign: "center", fontSize: 14,
                color: status === "error" ? "#C62828" : "#2E7D32",
              }}>
                {msg}
              </p>
            )}
          </form>
        )}

        {/* ── Events Preview (Phase 123) ── */}
        {events.length > 0 && (
          <div style={{ marginTop: 32 }}>
            <div style={{
              fontSize: 13, color: SUBTLE, textAlign: "center",
              marginBottom: 12, letterSpacing: 1
            }}>
              📨 近期法讯速览
            </div>
            {events.map(ev => (
              <div key={ev.id} style={{
                background: "white", borderRadius: 8, padding: "10px 16px",
                marginBottom: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                display: "flex", justifyContent: "space-between", alignItems: "center",
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, color: TXT, fontWeight: 500 }}>
                    {ev.title_zh || ev.title_en}
                  </div>
                  <div style={{ fontSize: 11, color: SUBTLE, marginTop: 2 }}>
                    {ev.teacher_zh || ev.teacher_en} · {ev.location}
                  </div>
                </div>
                {ev.start_date && (
                  <div style={{ fontSize: 11, color: GD, marginLeft: 12, whiteSpace: "nowrap" }}>
                    {ev.start_date.slice(5)}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* ── Footer ── */}
        <div style={{ textAlign: "center", color: SUBTLE, fontSize: 12, marginTop: 24, lineHeight: 1.8 }}>
          <div>订阅即表示同意接收 BTF 法讯邮件 · 我们不会将您的信息用于商业用途</div>
          <div>取消订阅请点击邮件底部的退订链接</div>
        </div>

      </div>
    </div>
  );
}
